// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BaNCZ","top":"styles_top__2amuV"};